import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  EMPLOYEE_LIST_SET_EMPLOYEES,
  EMPLOYEE_LIST_SET_DELETED_EMPLOYEE,
  EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL,
  EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL,
  EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_LIST_SET_OUTLETS,
  EMPLOYEE_LIST_SET_CHECKED_OUTLETS,
  EMPLOYEE_LIST_SET_PROFILE
} from 'actions/employees/list/constants'

// The initial application state
let initialState = {
  employees: [],
  outlets: [],
  checkedOutlets: [],
  showDeleteEmployeeModal: false,
  showAssignOutletModal: false,
  deletedEmployee: null,
  profile: null
}

// Takes care of changing the application state
function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {payload} = action

  switch (action.type) {
    case EMPLOYEE_LIST_SET_EMPLOYEES:
      return {...state, employees: payload.employees}
    case EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL:
      return {...state, showDeleteEmployeeModal: true}
    case EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL:
      return {...state, showDeleteEmployeeModal: false}
    case EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL:
      return {...state, showAssignOutletModal: true}
    case EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL:
      return {...state, showAssignOutletModal: false}
    case EMPLOYEE_LIST_SET_DELETED_EMPLOYEE:
      return {...state, deletedEmployee: payload.deletedEmployee}
    case EMPLOYEE_LIST_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case EMPLOYEE_LIST_SET_CHECKED_OUTLETS:
      let {outlets} = payload
      return {...state, checkedOutlets: outlets.map((o) => { return {...o} })}
    case EMPLOYEE_LIST_SET_PROFILE:
      return {...state, profile: payload.profile}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/employees/list.js